import React from 'react';
import { Award } from 'lucide-react';

export const WorkRequirements: React.FC = () => {
  return (
    <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6">
      <Award className="w-8 h-8 text-purple-300 mb-4" />
      <h3 className="text-lg font-semibold text-purple-200 mb-2">
        Requisitos
      </h3>
      <ul className="space-y-2 text-purple-200/70">
        <li>• Experiência comprovada</li>
        <li>• Certificações na área</li>
        <li>• Excelente comunicação</li>
        <li>• Compromisso e ética</li>
      </ul>
    </div>
  );
};